import React from 'react'
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import abilityBuild from '../../../shared/CASL/appAbility';
import { checkRoles } from '../../../hoc/CheckRoles';
import { RoleContext } from '../../../shared/enums';
import { RootState } from '../../../store';

import { Selection, CommandBar, DefaultButton, Dialog, DialogFooter, DialogType, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IDialogContentProps, IPivotStyles, mergeStyleSets, PrimaryButton, MessageBar, MessageBarType } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import { IUser } from '../../../shared/interfaces';
import { Unsubscribe } from '@casl/ability';
import usersService from '../../../services/users.service';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AddEditUserManager from '../../Admin/UsersManager/AddEditUserManager';
import UsersManagerTable from './UsersManagerTable';
import { toastRef } from '../../Layout/Layout';


const classNames = mergeStyleSets({
    overFlowHidden: {
        overflow: 'hidden'
    },
    detailsListRow: {
        '.ms-DetailsRow-check': {
            height: '100%',
            width: 36
        },
        '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
            paddingLeft: 0
        }
    }
});

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};
const pivotBarStyles: Partial<IPivotStyles> = {
    root: { padding: '0 24px' },
    itemContainer: { overflow: 'hidden', height: '100%' }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};


const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface UsersManagerProps {

}

type Props = UsersManagerProps & RouteComponentProps & PropsFromRedux;

export interface UsersManagerState {
    commandBarItems: ICommandBarItemProps[],
    selectedUserManager?: IUser,
    lateralPanelIsOpen: boolean,
    lateralPanelBodyContent: Function,
    lateralPanelSubmitFunction: Function,
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogSubmitFunction: Function,
    loadingUsersList: boolean,
    forceUsersManagerTableRefresh: boolean,
    allUsers: IUser[],
    showMessageBar: boolean,
    userMessageError: string,
}


class UsersManager extends React.Component<Props, UsersManagerState> {
    unsubscribeFromAbility: Unsubscribe = () => { };
    private userSelection: Selection;

    constructor(props) {
        super(props);


        this.userSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.userSelection.getSelection()[0] as IUser;
                this.setState({ selectedUserManager: selection })
            }
        })

        this.state = {
            commandBarItems: [],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingUsersList: false,
            forceUsersManagerTableRefresh: false,
            allUsers: [],
            showMessageBar: false,
            userMessageError: "",
        }

    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('create', 'IUser')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
            this.updateCommandBarItems();
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
        }
    }

    componentDidUpdate(oldProps: Props, oldState: UsersManagerState) {

        if (oldProps.currentAoo !== this.props.currentAoo ||
            oldState.selectedUserManager !== this.state.selectedUserManager) {
            this.updateCommandBarItems();
        }
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }

    updateCommandBarItems = () => {

        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('create', 'IUser'))
            newCommandBarItems.push(
                {
                    key: 'addUserManager',
                    iconProps: { iconName: 'AddFriend' },
                    text: 'Aggiungi utente',
                    onClick: this.addUserManagerHandler
                });

        if (abilityBuild.can('update', 'IUser') && this.state.selectedUserManager)
            newCommandBarItems.push({
                key: 'editUserManager',
                iconProps: { iconName: 'EditContact' },
                text: 'Modifica utente',
                onClick: this.editUserManagerHandler
            });

        if (abilityBuild.can('delete', 'IUser') && this.state.selectedUserManager)
            newCommandBarItems.push({
                key: 'deleteUserManager',
                iconProps: { iconName: 'UserRemove' },
                text: 'Elimina utente',
                onClick: this.deletetUserManagerHandler
            });

        this.setState({ commandBarItems: newCommandBarItems });
    }


    // Click sul button della commandbar - Aggiungi utente
    addUserManagerHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditUserManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuovo utente'
                    loading={false}
                    onSubmit={this.addUserLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={false}
                    peopleList={this.state.allUsers}
                />
            }
        );
        this.userSelection.setAllSelected(false);
    }

    // Click su salva del panel laterale - Aggiungi utente
    addUserLateralPanelSubmit = (user: Partial<IUser>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi aggiungere un nuovo utente?',
            },
            confirmDialogSubmitFunction: () => { this.addUserConfirmDialogSubmit(user) }
        })
    }

    // Click su conferma del confirm dialog - Aggiungi utente
    addUserConfirmDialogSubmit = (user: Partial<IUser>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingUsersList: true });
            let { forceUsersManagerTableRefresh } = this.state

            usersService.addUser(user)
                .then(result => {
                    this.setState({ forceUsersManagerTableRefresh: !forceUsersManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: user.displayName,
                        detail: `Utente aggiunto correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: user.displayName,
                        detail: `Utente non aggiunto correttamente`,
                        life: 5000
                    });

                    this.setState({ loadingUsersList: false });
                })

            this.setState({ confirmDialogIsOpen: false })
        }
    }

    // Click sul button della commandbar - Modifica utente
    editUserManagerHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditUserManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica utente'
                    loading={false}
                    selectedUserManager={this.state.selectedUserManager}
                    onSubmit={this.editUserLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={false}
                    peopleList={this.state.allUsers}
                />
            }
        );
    }

    // Click su salva del panel laterale - Modifica utente
    editUserLateralPanelSubmit = (user: Partial<IUser>) => {
        let { selectedUserManager } = this.state;
        if (selectedUserManager) {
            this.setState({
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi modificare l'utente ${selectedUserManager.displayName}?`,
                },
                confirmDialogSubmitFunction: () => { this.editUserConfirmDialogSubmit(user) }
            })
        }
    }

    // Click su conferma del confirm dialog - Modifica utente
    editUserConfirmDialogSubmit = (user: Partial<IUser>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingUsersList: true });
            let { forceUsersManagerTableRefresh } = this.state

            usersService.updateUser(user)
                .then(result => {
                    this.setState({ forceUsersManagerTableRefresh: !forceUsersManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: user.displayName,
                        detail: `Utente aggiornato correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    this.setState({ loadingUsersList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });

            this.setState({ confirmDialogIsOpen: false });
            this.userSelection.setAllSelected(false);
        }
    }

    // Click sul button della commandbar - Elimina utente
    deletetUserManagerHandler = () => {
        let { selectedUserManager } = this.state;
        if (selectedUserManager) {
            this.setState(
                {
                    lateralPanelIsOpen: false,
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: `Vuoi rimuovere l'utente ${selectedUserManager.displayName}?`,
                    },
                    confirmDialogSubmitFunction: () => { this.deleteUserManagerConfirmDialogSubmit() }
                }
            );
        }
    }

    // Click su conferma del confirm dialog - Elimina utente
    deleteUserManagerConfirmDialogSubmit = () => {
        if (this.props.currentAoo && this.state.selectedUserManager) {
            let { forceUsersManagerTableRefresh } = this.state

            let selectedUser: IUser = { ...this.state.selectedUserManager };

            usersService.deleteUser(selectedUser)
                .then(result => {
                    this.setState({ forceUsersManagerTableRefresh: !forceUsersManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: selectedUser.displayName,
                        detail: `Utente rimosso correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    let errorStatusCode = error.response.status;

                    // Se l'errorStatusCode è 400, nel messageBar mostro l'errore
                    if (errorStatusCode === 400) {
                        this.setState({ showMessageBar: true, userMessageError: error.response.data })
                    }

                    if (errorStatusCode === 500) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: selectedUser.displayName,
                            detail: `Utente non rimosso correttamente`,
                            life: 5000
                        });
                    }

                });

            this.setState({ confirmDialogIsOpen: false })
            this.userSelection.setAllSelected(false);
        }
    }

    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    onSelectUserManagerHandler = (selected) => {
        this.setState({ selectedUserManager: selected })
    }

    render() {

        return (
            <React.Fragment>

                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>
                </Dialog>

                <div className="users-manager-component" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}
                        />
                    }
                    {this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={true}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">
                            {this.state.userMessageError}
                        </MessageBar>
                    }


                    <UsersManagerTable
                        loadingUsersManagerTable={this.state.loadingUsersList}
                        userSelection={this.userSelection}
                        forceTableRefresh={this.state.forceUsersManagerTableRefresh}
                        onSelectUsersManagerHandler={(selected) => this.onSelectUserManagerHandler(selected)}
                        editUserManagerHandler={this.editUserManagerHandler!}
                        deletetUserManagerHandler={this.deletetUserManagerHandler!}
                    />


                </div>

            </React.Fragment >
        )
    }
}

export default connector(withRouter(checkRoles(UsersManager, RoleContext.Aoo)));
